import { selectIsFetching } from './state/manage/selector'

export default {

    selector: {
        selectIsFetching,
    },
}



// WEBPACK FOOTER //
// ./src/modules/email/index.js